import { Button } from "@mui/material";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../resources/global.css";
import "../resources/home.css";
import partyImage from "../resources/images/home/party.png";
import profileImage from "../resources/images/home/profile.png";
import Logo from "./commons/Logo";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

class Home extends Component {
  state = {};
  render() {
    return (
      <div className="intro">
        <div className="intro-section" id="intro-hero" style={{
          position: 'relative'
        }}>
          <div>
            <div className="heading-container">
              <h1
                className="heading"
                style={{
                  marginTop: 0,
                }}
              >
                Show the world who you are
              </h1>
              <Logo />
            </div>
            <div
              style={{
                marginTop: 40,
              }}
            >
              <Link
                to="/register"
                style={{
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                <Button className="button" variant="contained" size="large">
                  Register
                </Button>
              </Link>
              <Link
                to="/login"
                style={{
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                <Button
                  className="button"
                  variant="contained"
                  size="large"
                  sx={{
                    marginLeft: "30px",
                  }}
                >
                  Login
                </Button>
              </Link>
            </div>
            <div style={{
              position: 'absolute',
              bottom: 10
            }} id="home-legal">
              <div className="legal-notice" style={{
                color: 'grey'
              }}>
                <div>
                  <a
                    href="/tos"
                    target="_blank"
                    style={{
                      marginRight: 5,
                    }}
                  >
                    Terms of Use
                  </a>
                  ·
                  <a
                    href="/privacy"
                    target="_blank"
                    style={{
                      marginLeft: 5,
                    }}
                  >
                    Privacy Policy
                  </a>
                </div>
                © 2022 OuMedia.
              </div>
            </div>
          </div>
        </div>
        <div className="intro-section" id="intro-images">
          <div id="intro-image-container">
            <Carousel
              dynamicHeight={true}
              showThumbs={false}
              showArrows={false}
              autoPlay={true}
              interval={5000}
              infiniteLoop={true}
              transitionTime={1000}
              width={600}
              showStatus={false}
            >
              <div className="intro-image">
                <img src={partyImage} />
              </div>
              <div className="intro-image">
                <img src={profileImage} />
              </div>
            </Carousel>
          </div>
          <div id="triangle"></div>
        </div>
      </div>
    );
  }
}

export default Home;
